/* ==========================================================================
   Loga mediów — "Logo Blur Carousel" (21.09.2026)

   Martina chciała dla "Media o StethoMe" wzór Framer:
   framerusercontent.com/modules/l1tQauLvNR2KKFNdOS9j/VcV54qPqdfMNxJPWzmch/LogoBlur.js
   ("#98 Logo Blur Carousel" — opis w komentarzu tamtego pliku: "A responsive
   row of brand logos. Each slot periodically swaps to a new logo with
   a blur + vertical roll-up transition, rippling left-to-right with
   a stagger."). To komponent Framer (React + Framer Motion) — nie ma ich
   w tym stacku, więc zachowanie przepisane na waniliowy JS, 1:1 z logiką
   źródła (przeczytanego, nie wklejonego): stały rząd slotów, pula logo
   większa niż liczba widocznych naraz, każdy slot co `interval` s podmienia
   się na kolejne z puli z przejściem blur+zjazd+fade, fala lewo→prawo
   (`stagger`), pauza na hover/poza kadrem/kartą w tle, bez cyklu przy
   prefers-reduced-motion (sloty stoją nieruchomo na pierwszych N logo).

   Dane: te same 12 wzmianek co karuzela na Family (przed przeniesieniem)
   i karty w /newsroom/ — pełna lista z linkami w newsroom/items.json,
   ale tu jest fizycznie osobna tablica, bo ten widget nie czyta JSON-a
   (to prosty, samodzielny moduł strony głównej, jak media-slider-wrapper
   przed nim). Przy zmianie linku zmień w OBU miejscach.
   ========================================================================== */
(function () {
  const container = document.querySelector("[data-media-logoblur]");
  if (!container) return;

  const POOL = [
    {
      src: "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/671ffc366b0d886b0f33f12f_medgadget-logo.avif",
      alt: "Medgadget",
      href: "https://www.medgadget.com/2019/06/stethome-at-home-stethoscope-for-detection-of-respiratory-issues-in-kids-cleared-in-europe.html",
    },
    {
      src: "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/671ffc36270d3c6a5b4a5c03_forbes-logo2.avif",
      alt: "Forbes",
      href: "https://www.forbes.com/sites/nicholasfearn/2019/10/09/medtech-startup-uses-ai-to-identify-respiratory-issues-in-children/",
    },
    {
      src: "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/671ffc35000c026d2fc77046_eus-logo2.avif",
      alt: "EU-Startups",
      href: "https://www.eu-startups.com/2019/02/10-polish-startups-to-look-out-for-in-2019/",
    },
    {
      src: "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/671ffc351baacb723dafd37c_wt-logo.avif",
      alt: "Wearable Technologies",
      href: "https://www.wearable-technologies.com/2019/06/stethome-at-home-stethoscope-for-detecting-respiratory-problems-in-kids-gets-ce-mark/",
    },
    {
      src: "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/671ffc3560927484d2ea75cd_hti-logo.avif",
      alt: "Health Tech Insider",
      href: "https://healthtechinsider.com/2019/06/17/wireless-stethoscope-with-ai-gets-ce-certification/",
    },
    {
      src: "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/671ffc35aa6a9582cabae1d2_nsmd-logo.avif",
      alt: "NS Medical Devices",
      href: "https://www.nsmedicaldevices.com/news/what-is-stethome-the-ai-powered-stethoscopes-that-can-be-used-at-home/",
    },
    {
      src: "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/671ffc35b6b1af69b60ab124_ehh-logo2.avif",
      alt: "eHealth Hub",
      href: "https://www.ehealth-hub.eu/himss-2019-winners-ec2vc/",
    },
    {
      src: "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/671ffc350d7d183d04c0b2f3_mhn-logo.avif",
      alt: "MobiHealthNews",
      href: "https://www.mobihealthnews.com/content/ai-enables-stethome-smart-stethoscope-monitor-kids-health-remotely",
    },
    {
      src: "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/671ffc35da8d8fb7dd162ff5_th-logo.avif",
      alt: "TrendHunter",
      href: "https://www.trendhunter.com/trends/smart-stethoscope",
    },
    {
      src: "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/671ffc3460363b8d41a0f449_eb-logo2.png",
      alt: "European Business",
      href: "https://www.european-business.com/interviews/stethomer/stethomer-scoping-new-opportunities-for-the-stethoscope",
    },
    {
      src: "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/671ffc38f065ded8622e1159_wired-logo.avif",
      alt: "Wired",
      href: "https://www.wired.co.uk/article/bluetooh-stethoscope-stethome",
    },
    {
      src: "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/671ffc34cc94d83d59345bb6_tvn-logo.avif",
      alt: "Fakty TVN24",
      href: "https://fakty.tvn24.pl/ogladaj-online,60/e-stetoskop-testowany-przez-polskich-pacjentow-lekarze-moga-osluchiwac-ich-na-odleglosc,1072661.html",
    },
  ];

  // Wartości domyślne komponentu źródłowego (desktopCount/mobileCount/
  // breakpoint/interval/stagger) — nie zmieniane, to jest ten wzór.
  const DESKTOP_COUNT = 5;
  const MOBILE_COUNT = 3;
  const BREAKPOINT = 640;
  const INTERVAL_MS = 3000;
  const STAGGER_MS = 150;
  const OUT_MS = 400;
  const IN_MS = 500;

  const reducedMotionMq = window.matchMedia("(prefers-reduced-motion: reduce)");
  let reducedMotion = reducedMotionMq.matches;
  reducedMotionMq.addEventListener("change", (e) => {
    reducedMotion = e.matches;
    refreshCycle();
  });

  let visibleCount = 0;
  let slotIndices = [];
  let intervalId = null;
  let swapTimeouts = [];
  let paused = false;
  let inView = true;

  function visibleCountFor() {
    const n = window.innerWidth < BREAKPOINT ? MOBILE_COUNT : DESKTOP_COUNT;
    return Math.max(1, Math.min(n, POOL.length));
  }

  function buildSlots(count) {
    container.innerHTML = "";
    slotIndices = Array.from({ length: count }, (_, i) => i % POOL.length);
    const frag = document.createDocumentFragment();
    for (let i = 0; i < count; i++) {
      const item = POOL[slotIndices[i]];
      const slot = document.createElement("div");
      slot.className = "logoblur__slot";
      const a = document.createElement("a");
      a.href = item.href;
      a.target = "_blank";
      a.rel = "noopener";
      const img = document.createElement("img");
      img.src = item.src;
      img.alt = item.alt;
      img.loading = "lazy";
      a.appendChild(img);
      slot.appendChild(a);
      frag.appendChild(slot);
    }
    container.appendChild(frag);
  }

  // Blur + pionowy zjazd + fade: wyjście w górę, wejście od dołu — tak jak
  // domyślny kierunek "up" w źródle. Dwuetapowe: najpierw wygaszamy stary
  // obrazek, dopiero po OUT_MS podmieniamy src i wjeżdżamy nowym od dołu.
  function swapSlot(i) {
    const slot = container.children[i];
    if (!slot) return;
    const link = slot.querySelector("a");
    const img = slot.querySelector("img");
    if (!link || !img) return;

    slotIndices[i] = (slotIndices[i] + visibleCount) % POOL.length;
    const next = POOL[slotIndices[i]];

    img.style.transition = `opacity ${OUT_MS}ms ease, filter ${OUT_MS}ms ease, transform ${OUT_MS}ms ease`;
    img.style.opacity = "0";
    img.style.filter = "blur(8px) grayscale(100%)";
    img.style.transform = "translateY(-60%)";

    const t = window.setTimeout(() => {
      link.href = next.href;
      img.src = next.src;
      img.alt = next.alt;
      img.style.transition = "none";
      img.style.transform = "translateY(60%)";
      // Wymuszony reflow, żeby przeglądarka zauważyła stan "bez tranzycji"
      // przed włączeniem go z powrotem — inaczej wjazd od dołu by nie zagrał.
      void img.offsetWidth;
      img.style.transition = `opacity ${IN_MS}ms ease, filter ${IN_MS}ms ease, transform ${IN_MS}ms ease`;
      img.style.transform = "translateY(0)";
      img.style.opacity = "0.6";
      img.style.filter = "grayscale(100%)";
    }, OUT_MS);
    swapTimeouts.push(t);
  }

  function tick() {
    swapTimeouts.forEach((t) => window.clearTimeout(t));
    swapTimeouts = [];
    for (let i = 0; i < visibleCount; i++) {
      const t = window.setTimeout(() => swapSlot(i), i * STAGGER_MS);
      swapTimeouts.push(t);
    }
  }

  function canCycle() {
    return !reducedMotion && POOL.length > visibleCount && inView && !document.hidden && !paused;
  }

  function stopCycle() {
    if (intervalId) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  }

  function startCycle() {
    stopCycle();
    if (!canCycle()) return;
    intervalId = window.setInterval(tick, INTERVAL_MS);
  }

  function refreshCycle() {
    if (canCycle()) startCycle();
    else stopCycle();
  }

  function init() {
    visibleCount = visibleCountFor();
    buildSlots(visibleCount);
    refreshCycle();
  }

  init();

  // Debounce przez requestAnimationFrame — przebudowa slotów tylko wtedy,
  // gdy liczba widocznych faktycznie się zmienia (przejście przez breakpoint),
  // nie na każdy piksel resize.
  let resizeRaf = null;
  window.addEventListener("resize", () => {
    if (resizeRaf) return;
    resizeRaf = window.requestAnimationFrame(() => {
      resizeRaf = null;
      const next = visibleCountFor();
      if (next !== visibleCount) {
        visibleCount = next;
        buildSlots(visibleCount);
        refreshCycle();
      }
    });
  });

  container.addEventListener("pointerenter", () => {
    paused = true;
    refreshCycle();
  });
  container.addEventListener("pointerleave", () => {
    paused = false;
    refreshCycle();
  });

  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      ([entry]) => {
        inView = entry.isIntersecting;
        refreshCycle();
      },
      { rootMargin: "100px" }
    );
    io.observe(container);
  }

  document.addEventListener("visibilitychange", refreshCycle);
})();
